import React, { Component } from 'react';
import { Modal } from 'antd';
import CKEditor from '../../../../components/elements/Editor';

const types = [
  {
    key: 'journal',
    title: 'Bài báo khoa học',
    description: 'Tác giả. (Năm xuất bản). Tiêu đề bài báo. Tên tạp chí, số tập (số phát hành), số trang.',
  },
  {
    key: 'textbook',
    title: 'Giáo trình',
    description: 'Tác giả. (năm xuất bản). Tựa sách. Thành phố: NXB',
  },
  {
    key: 'project',
    title: 'Đề tài',
    description: 'Tác giả. (Năm xuất bản). Tiêu đề nghiên cứu. Loại nghiên cứu.',
  },
  {
    key: 'achievements',
    title: 'Thành tích',
    description: '',
  },
];

class InputModal extends Component {
  render() {
    const { type, visible, onCancel, onSubmit, content, onChange } = this.props;

    const data = types.find(item => item.key === type);

    return (
      <Modal
        title={data.title}
        visible={visible}
        onOk={onSubmit}
        onCancel={onCancel}
        okText="Xong"
        cancelText="Huỷ"
      >
        <p>{data.description}</p><br />
        <CKEditor
          placeholder="Nội dung tin"
          onChange={onChange}
          value={content}
        />
      </Modal>
    );
  }
}

export default InputModal;



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Profile/InputModal.js